import React, { useEffect, useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Dropdown } from "primereact/dropdown";
import apiUrls from "../../constants/apiUrls";
import apis from "../../services/apis";
import { toast } from "react-toastify";
import { customFormDataPost } from "../../helper/api-helper/apiHerlpers";
import apiCommonParams from "../../constants/apiCommonParams";
import "../project/project.css";
import { useSmarkState } from "../../Context/KeycloakContext";
import AppContext from "../../Context/AppContext";

const Release = (props) => {
  const userDetails = useSmarkState();
  const storedToken = localStorage.getItem("keycloakToken");
  const { applicationId, siteId } = useContext(AppContext);

  const [projectId, setProjectId] = useState(null);
  const [releaseName, setReleaseName] = useState("");
  const [masterProjects, setMasterProject] = useState([]);

  const [errorRelease, setErrorRelease] = useState(false);
  const [errorProject, setErrorProject] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getProjects();

    // Fix bootstrap tabindex issue
    setTimeout(() => {
      const ele = document.getElementsByClassName("modal show");
      if (ele && ele.length > 0) {
        ele[0].removeAttribute("tabindex");
      }
    }, 0);
  }, []);

  const onHideRelease = () => {
    if (!isLoading) {
      props.onHideReleaseEvent();
    }
  };

  const getProjects = async () => {
    const projects = await apis.getProjects(
      applicationId,
      siteId,
      userDetails.userId,
      userDetails.isAdminUser,
      storedToken
    );

    const projectPermissions =
      JSON.parse(localStorage.getItem("projectPermissions")) || {};
    const isGlobalAdmin =
      JSON.parse(localStorage.getItem("isGlobalAdmin")) || false;

    const filteredProjects = isGlobalAdmin
      ? projects
      : projects.filter((p) => {
          const perms = projectPermissions[p.value] || [];
          return perms.includes("AR"); // Add Release permission
        });

    setMasterProject(filteredProjects || []);
  };

  const projectDropdownChangeHandler = (event) => {
    setProjectId(event.value);
    setErrorProject(false);
  };

  const releaseChangeHandler = (event) => {
    setReleaseName(event.target.value);
    setErrorRelease(false);
  };

  const submitButtonHandler = (event) => {
    event.preventDefault();

    if (!releaseName.trim()) setErrorRelease(true);
    if (!projectId) setErrorProject(true);

    if (!releaseName.trim() || !projectId) return;

    setIsLoading(true);

    const body = new FormData();
    const data = {
      releaseId: 0,
      releaseName: releaseName,
      releaseNumber: "1.0.1",
      projectId: projectId,
      applicationId: applicationId,
      siteId: siteId,
      userCreated: apiCommonParams.userCreated,
      userModified: apiCommonParams.userModified,
      createdTime: apiCommonParams.createdTime,
      updatedTime: apiCommonParams.updatedTime,
      startDate: apiCommonParams.startDate,
      endDate: apiCommonParams.endDate,
      type: "regular",
      status: "in progress",
    };

    body.append("release", JSON.stringify(data));
    body.append("swcmTicket", apiCommonParams.swcmTicket);
    body.append("userid", userDetails.userId);

    customFormDataPost(apiUrls.saveRelease, body, storedToken)
      .then((res) => {
        if (res.response === "success") {
          props.loadMasterReleaseDdl(storedToken);
          toast.success("Release added successfully");
          props.onHideReleaseEvent();
        } else {
          toast.warning(res.response);
        }
      })
      .catch(() => {
        toast.error("Error");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Modal show={true} onHide={onHideRelease} backdrop="static">
      <Modal.Header closeButton={!isLoading}>
        <Modal.Title>Add New Release</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="form-group">
          <label>Project</label>
          <Dropdown
            filter
            placeholder="--Select project--"
            value={projectId}
            onChange={projectDropdownChangeHandler}
            style={{ width: "100%", zIndex: "99999" }}
            options={masterProjects}
            disabled={isLoading}
          />
          {errorProject && (
            <span className="form-error text-danger">
              Project is required
            </span>
          )}
        </div>

        <div className="form-group">
          <label>Release</label>
          <input
            type="text"
            className="form-control required-field"
            placeholder="Release name"
            value={releaseName}
            onChange={releaseChangeHandler}
            disabled={isLoading}
          />
          {errorRelease && (
            <span className="form-error text-danger">
              Release name is required
            </span>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="primary"
          onClick={submitButtonHandler}
          disabled={isLoading}
        >
          {isLoading ? "Saving..." : "Submit"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Release;
